module.exports = __webpack_public_path__ + "img/fin.c85d6aaa.png";